export const environment = {
	production: false,
	URL_SUB_DOMAIN: 'EBUERO_SUB_DOMAIN',
	FALLBACK_DOMAIN: undefined,
	assetUrl: 'EBUERO_STATIC_PATH_PLACEHOLDER/web-components/connect',
	baseUrl: 'EBUERO_SERVER_PATH_PLACEHOLDER',
	feedbackAssetUrl: 'EBUERO_STATIC_PATH_PLACEHOLDER/web-components/wc-callnote-feedback',
};
